import { useForm } from 'react-hook-form';
import { Alert, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ModalForm from '@components/common/hooks/useFormModal/ModalForm';
import RadioButtonGroup from '@components/common/HookFormMui/RadioButtonGroup';
import { setToOptions } from '@lib/utils';
import { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/system';

const EventCancelModal = ({
  onSubmit,
  submitRef,
  defaultValues = {},
  statuses = {},
  topAlert,
  bottomAlert,
  options,
  setOptions,
}) => {
  const [originalConfirmationText] = useState(options.confirmationText);

  const [config, setConfig] = useState({
    reasons: new Set([
      'Partner requested to cancel',
      'Staffing capacity',
      'Other',
    ]),
    topAlert,
    bottomAlert,
  });

  const form = useForm({
    mode: 'all',
    reValidateMode: 'all',
    defaultValues,
  });

  const [selectedReason, setSelectedReason] = useState('');

  const watchReason = form.watch('cancel_reason');
  if (watchReason !== selectedReason) {
    setSelectedReason(watchReason);
  }

  const setButtons = useCallback((confirmationText = null, cancellationText = null) => {
    const update = {};
    if (confirmationText && confirmationText !== options.confirmationText) {
      update.confirmationText = confirmationText;
    }
    if (cancellationText && cancellationText !== options.cancellationText) {
      update.cancelationText = cancellationText;
    }
    setOptions({ ...options, ...update });
  }, [options, setOptions]);

  useEffect(() => {
    if (!statuses.COMPLETED && !config.reasons.has('Created by mistake')) {
      const reasons = Array.from(config.reasons);
      reasons.splice(-1, 0, 'Created by mistake');
      setConfig({ ...config, reasons: new Set(reasons) });
    }
  }, [statuses.COMPLETED, config, setConfig]);

  useEffect(() => {
    const update = { ...config };
    if (selectedReason) {
      const mistake = selectedReason === 'Created by mistake';
      const confirmationText = mistake ? 'Delete Event' : originalConfirmationText;
      setButtons(confirmationText);
    }
    if (!statuses.COMPLETED) {
      if (selectedReason === 'Created by mistake') {
        update.bottomAlert = `Because this event was created by mistake, the event and all of its sessions will be deleted instead of canceled. This cannot be undone.`;
      } else if (selectedReason) {
        update.bottomAlert = bottomAlert;
      }
      setConfig({ ...update });
    }
    // eslint-disable-next-line
  }, [selectedReason]);

  return (
    <ModalForm
      form={form}
      onSubmit={onSubmit}
      submitRef={submitRef}
      sx={{
        marginTop: '-16px',
      }}
    >
      <Grid container spacing={1}>
        {config.topAlert && (
          <Grid xs={12} spacing={0}>
            <Alert severity="warning">
              {config.topAlert}
            </Alert>
          </Grid>
        )}
        <Grid xs={12} sm={10}>
          <RadioButtonGroup
            key="key-cancel_reasons"
            id="field-cancel_reason"
            name="cancel_reason"
            formLabelProps={{
              component: 'h2',
              style: {
                marginTop: 0,
                fontSize: '20px',
              }
            }}
            placeholder={'Select reason'}
            variant={'standard'}
            control={form.control}
            fullWidth
            required
            otherTextField
            otherTextFieldLabel={'If Other, please describe reason*'}
            otherTextFieldHiddenSpace
            options={setToOptions(config.reasons)}
          />
        </Grid>
        <Box height="80px" paddingTop={0.5}>
          <Grid xs={12} sx={{ visibility: config.bottomAlert ? 'visible' : 'hidden'}}>
            <Alert severity="warning">
              {config.bottomAlert}
            </Alert>
          </Grid>
        </Box>
      </Grid>
    </ModalForm>
  );
};

export default EventCancelModal;
